export default __webpack_public_path__ + "static/media/icon_steamer_2.a5ab1e0c.svg";